import { api } from './config'

interface ResSingin {
	access_token: string
}

export const signinPartner = (key: string) => api.post<ResSingin>('auth', { key, password: 'pass' })
